import { render, staticRenderFns } from "./deliveryCarList.vue?vue&type=template&id=47c98fe1&scoped=true"
import script from "./deliveryCarList.vue?vue&type=script&lang=js"
export * from "./deliveryCarList.vue?vue&type=script&lang=js"
import style0 from "./deliveryCarList.vue?vue&type=style&index=0&id=47c98fe1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c98fe1",
  null
  
)

export default component.exports